/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Store
import { actions } from 'core/store'

// Assets
import { CloseIcon } from 'assets/images/Icons'

// Views
import { Button } from 'views/components'
// Styled Elements
import { TableButtonWrapper, TableRowWrapper, Title, ColWrapper, IPContainer } from './ApiKeysTableItem.elements'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function ApiKeysTableItem(props) {
  // Destructure
  const { actions, data } = props

  // Store Actions
  const { toggleRemoveApiKeyModal, setApiKeyToDelete } = actions

  // Functions
  const handleRemove = () => {
    setApiKeyToDelete(data)
    toggleRemoveApiKeyModal()
  }

  return (
    <TableButtonWrapper>
      <TableRowWrapper>
        <ColWrapper>
          <Title>{data.label}</Title>
        </ColWrapper>
        <ColWrapper>
          {data?.allowed_ips && (
            <IPContainer>
              {data?.allowed_ips?.split(',')?.map((item, i) => (
                <Title key={`${item}${i}`}>{`${item}${i !== data.allowed_ips.split(',').length - 1 ? ',' : ''}`}</Title>
              ))}
            </IPContainer>
          )}
        </ColWrapper>
        <ColWrapper>
          <Title>{moment(data.created).format('MMM D, YYYY')}</Title>
        </ColWrapper>
        <ColWrapper>
          <Title>{moment(data.expires).format('MMM D, YYYY')}</Title>
        </ColWrapper>
        <ColWrapper>
          <Button
            style={{ alignItems: 'center' }}
            variant="outlined"
            onClick={handleRemove}
            size="small"
            endIcon={<CloseIcon size={10} />}
          >
            Remove
          </Button>
        </ColWrapper>
      </TableRowWrapper>
    </TableButtonWrapper>
  )
}

// Default Props
ApiKeysTableItem.defaultProps = {
  actions: {},
  data: {},
}

// Proptypes Validation
ApiKeysTableItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    allowed_ips: PropTypes.string,
    created: PropTypes.string,
    expires: PropTypes.string,
  }),
  actions: PropTypes.shape({
    setApiKeyToDelete: PropTypes.func,
    toggleRemoveApiKeyModal: PropTypes.func,
    showAlert: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiKeysTableItem)
